import { createContext } from "react";
var Fees = createContext(0);
export default Fees;
